import { HttpClient, HttpHeaders } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { catchError, Observable, of, retry, switchMap } from 'rxjs';
import { environment } from 'src/environments/environment';
import { AuthService } from '../auth/auth.service';

@Injectable({
    providedIn: 'root',
})

export class AdvisorService {

    constructor(private http: HttpClient) { }
    baseUrl = environment.URL_MULESOFT_ASESORES;
    private authService = inject(AuthService);


    public getAdvisorInformation(sessionId: string, BodyAdvisor: any): Observable<any> {

        return this.authService.createAuthHeaders().pipe(
            switchMap(headers => {
                
                const urlWithTimestamp = `${this.baseUrl}/${BodyAdvisor}`;


                return this.http.get<any>(urlWithTimestamp, { headers }).pipe(
                    retry(2),
                    catchError((error) => {
                        console.error(`Failed request for getAdvisorInformation ${BodyAdvisor}:`, error);
                        return of(null); // Retornar null en caso de error para permitir que el flujo continúe
                    })
                );
            })
        );
    }


    public getAdvisorsList(sessionId: string): Observable<any> {

        return this.authService.createAuthHeaders().pipe(
            switchMap(headers =>{
                
                const urlWithTimestamp = `${this.baseUrl}`;
                
                return this.http.get<any>(urlWithTimestamp, { headers }).pipe(
                    retry(2),
                    catchError((error) => {
                        console.error(`Failed request for getAdvisorList: ${error}`);
                        return of(null); // Retornar null en caso de error para permitir que el flujo continúe
                    })
                );

            })
        );
    }
        

}
